import { useNavigate, useParams } from 'react-router-dom';
import './BlogDetails.css';
import MainLayout from '../../layouts/MainLayout/MainLayout';
import { useEffect, useState } from 'react';
import { Button, Flex, Loader, Stack, Badge, Title, Text, Container, Image, List, Avatar, Divider } from '@mantine/core';
import { IconArrowLeft, IconBrandFacebook, IconBrandGmail, IconBrandInstagram, IconBrandLinkedin, IconBrandWhatsapp, IconCalendar, IconMail, IconUser } from '@tabler/icons-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { getRelativeDate } from '../../utils/getRelativeDate';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';


const renderByType = (type) => {
   if (!type) return 'Profesor'
   if (type === 'student') return 'Estudiante'
   if (type === 'staff') return 'Staff'
   return 'Profesor'
}

const renderRRSSIcon = (rrss) => {
   if (!rrss) return <></>
   const value = rrss.toLowerCase()
   let icon
   if (value === 'facebook') icon = <IconBrandFacebook />
   if (value === 'linkedin') icon = <IconBrandLinkedin />
   if (value === 'instagram') icon = <IconBrandInstagram />
   if (value === 'whatsapp') icon = <IconBrandWhatsapp />
   if (value === 'email') icon = <IconMail />
   return icon
}

export default function BlogDetails() {
   const navigate = useNavigate();
   const { slugName } = useParams();

   const [state, setState] = useState({
      isLoading: false,
      error: false,
      data: null
   });

   useEffect(() => {
      const getPost = async () => {
         try {
            setState(prev => ({ ...prev, isLoading: true }));
            const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/blog/${slugName}?view=true`;
            const { data } = await axios.get(URL);
            setState(prev => ({ ...prev, data }));
         } catch (error) {
            setState(prev => ({ ...prev, error: true }));
         } finally {
            setState(prev => ({ ...prev, isLoading: false }));
         }
      };
      getPost();
   }, [slugName]);



   return (
      <MainLayout>
         <div className='BlogDetails-main-container'>

            {state.isLoading && (
               <Flex justify="center" align="center" h="50vh">
                  <Loader size="xl" variant="dots" />
               </Flex>
            )}

            {state.error && (
               <Text c="red" fz='var(--fs-body)' ta="center">Hubo un error al cargar el artículo. Intenta de nuevo.</Text>
            )}

            {state.data && !state.isLoading && (
               <>
                  <Flex justify='start'>
                     <Button
                        leftSection={<IconArrowLeft size={16} />}
                        variant='outline'
                        color="var(--color-text-primary)"
                        onClick={() => navigate('/blog')}
                        className="back-button"
                     >
                        Volver al blog
                     </Button>
                  </Flex>

                  <header className="BlogDetails-header">
                     {state.data.category && (
                        <Badge variant="filled" color="var(--color-tertiary)" mb="sm">
                           {state.data.category}
                        </Badge>
                     )}

                     <Title order={1} className='BlogPage--pageTitle'>
                        {state.data.title}
                     </Title>

                     <Flex gap="md" mt="md" wrap="wrap" className="BlogDetails-meta">
                        <Flex align="center" gap={5}>
                           <IconCalendar size={16} stroke={1.5} />
                           <Text fz='var(--fs-small)' c="var(--color-text-primary)">{getRelativeDate(state.data.date)}</Text>
                        </Flex>
                        {state.data.author && (
                           <Flex align="center" gap={5}>
                              <IconUser size={16} stroke={1.5} />
                              <Text fz='var(--fs-small)' c="var(--color-text-primary)">Por <strong>{state.data.author}</strong></Text>
                           </Flex>
                        )}
                     </Flex>
                  </header>


                  {state.data.image && (
                     <Image
                        radius="md"
                        src={state.data.image}
                        alt={state.data.title}
                        className='BlogDetails--image'
                        fallbackSrc="https://placehold.co/600x400?text=No+Image"
                     />
                  )}

                  {state.data.featuredUsers && state.data.featuredUsers.length > 0 && (
                     <div className='BlogDetails-featuredUsers-container'>
                        <Text fz='var(--fs-small)' fw={600} c="var(--color-text-primary)" mb="sm">
                           Referentes destacados en este artículo
                        </Text>

                        <div className='BlogDetails-featuredUsers-track'>
                           {state.data.featuredUsers.map((user) => (
                              <div
                                 key={user._id}
                                 className='BlogDetails-featuredUser-card'

                              >
                                 <Avatar
                                    size={100}
                                    h='100%'
                                    radius={'1rem'}
                                    src={user.profilePicture}
                                    m={0} p={0}
                                    alt={`${user.name} ${user.lastname}`}
                                 />
                                 <Stack gap={0} pb={10}>
                                    <Text fz='var(--fs-small)' fw={600} ta="center" mt="xs">
                                       {user.name} {user.lastname}
                                    </Text>
                                    <Badge mt={4}>{renderByType(user.type)}</Badge>
                                    <Divider mt={8} variant='dotted' />
                                    <Flex justify='space-between'>
                                       {user.about?.rrss && Object.keys(user.about.rrss).length > 0 && (
                                          <Flex gap={6} justify="start" align='start' mt={6}>
                                             {Object.entries(user.about.rrss).map(([platform, url]) => (
                                                url && (
                                                   <Link
                                                      key={platform}
                                                      to={url}
                                                      target="_blank"
                                                      className='BlogDetails-rrss-link'
                                                      rel="noopener noreferrer"
                                                      style={{ color: 'var(--color-text-primary)', display: 'flex' }}
                                                   >
                                                      {renderRRSSIcon(platform)}
                                                   </Link>
                                                )
                                             ))}

                                          </Flex>

                                       )}
                                       {user.slugName && <span onClick={() => navigate(`/profesores/${user.slugName}`)} style={{ marginTop: ".6rem", cursor: "pointer" }} className="hc-link">Ver más →</span>}
                                    </Flex>


                                 </Stack>
                              </div>
                           ))}
                        </div>
                     </div>
                  )}

                  <div className='BlogDetails-content-wrapper'>
                     <div className="BlogDetails--markdown">
                        <ReactMarkdown
                           remarkPlugins={[remarkGfm]}
                           components={{
                              p: ({ node, ...props }) => (
                                 <Text fz='var(--fs-body)' className='BlogDetails--text' {...props} />
                              ),
                              h1: ({ node, ...props }) => <Title order={2} mt="lg" {...props} />,
                              h2: ({ node, ...props }) => <Title order={3} mt="md" {...props} />,
                              h3: ({ node, ...props }) => <Title order={4} mt="md" {...props} />,
                              h4: ({ node, ...props }) => <Title order={5} mt="sm" {...props} />,
                              ul: ({ node, ...props }) => (
                                 <List spacing="xs" fz='var(--fs-body)' {...props} />
                              ),

                              ol: ({ node, ...props }) => (
                                 <List type="ordered" spacing="xs" fz='var(--fs-body)' {...props} />
                              ),
                              li: ({ node, ...props }) => <List.Item {...props} />,
                              strong: ({ node, ...props }) => <strong style={{ fontWeight: 700 }} {...props} />,
                              em: ({ node, ...props }) => <em style={{ fontStyle: 'italic' }} {...props} />,
                              hr: () => <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid var(--color-border, #e0e0e0)' }} />,
                              a: ({ node, href, children, ...props }) => (
                                 <a
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'var(--color-tertiary)', textDecoration: 'underline' }}
                                    {...props}
                                 >
                                    {children}
                                 </a>
                              ),
                              blockquote: ({ node, ...props }) => (
                                 <div
                                    style={{
                                       borderLeft: '4px solid var(--color-tertiary)',
                                       backgroundColor: 'var(--color-tertiary-light, #f5f5f5)',
                                       padding: '1rem 1.25rem',
                                       margin: '1.5rem 0',
                                       borderRadius: '4px',
                                    }}
                                    {...props}
                                 />
                              ),
                              table: ({ node, ...props }) => (
                                 <div style={{ overflowX: 'auto', margin: '1.5rem 0' }}>
                                    <table
                                       style={{ width: '100%', borderCollapse: 'collapse', fontSize: 'var(--fs-body)' }}
                                       {...props}
                                    />
                                 </div>
                              ),
                              thead: ({ node, ...props }) => (
                                 <thead style={{ backgroundColor: 'var(--color-tertiary-light, #f5f5f5)' }} {...props} />
                              ),
                              th: ({ node, ...props }) => (
                                 <th
                                    style={{
                                       textAlign: 'left',
                                       padding: '0.75rem 1rem',
                                       fontWeight: 700,
                                       borderBottom: '2px solid var(--color-tertiary)',
                                    }}
                                    {...props}
                                 />
                              ),
                              td: ({ node, ...props }) => (
                                 <td
                                    style={{ padding: '0.75rem 1rem', borderBottom: '1px solid var(--color-border, #e0e0e0)' }}
                                    {...props}
                                 />
                              ),
                           }}
                        >
                           {state.data?.content}
                        </ReactMarkdown>
                     </div>

                     {state.data.tags && state.data.tags.length > 0 && (
                        <Flex gap="xs" mt="xl" wrap="wrap">
                           {state.data.tags.map(tag => (
                              <Badge key={tag} variant="outline" color="var(--color-text-primary)">
                                 #{tag}
                              </Badge>
                           ))}
                        </Flex>
                     )}
                  </div>
               </>
            )}
         </div>
      </MainLayout>
   );
}